import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import SmartMailList from './components/SmartMailList'


const { Cell } = ResponsiveGrid;

const SmartMail = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="智慧信箱列表"
        breadcrumbs={[
          {
            name: '智慧信箱',
          },
          {
            name: '智慧信箱列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <SmartMailList />
    </Cell>
  </ResponsiveGrid>
);

export default SmartMail;
